import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const logsRoutes: Routes = [
	{
		path: 'logs',
		children: [
			{
				path: 'email-logs',
				canMatch: [roleGuard],
				data: { allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN] },
				loadComponent: () => import('./pages/email-logs/email-logs-page.component').then(c => c.EmailLogsPageComponent)
			},
			{
				path: 'user-actions-logs',
				canMatch: [roleGuard],
				data: { allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN] },
				loadComponent: () =>
					import('./pages/user-actions-logs/user-actions-logs-page.component').then(c => c.UserActionsLogsPageComponent)
			}
		]
	}
];
